// extracted by mini-css-extract-plugin
export default {"title-box":"title-box_title-box__Lj-W5","title":"title-box_title__DxkxO","btn":"title-box_btn__hXE1-","desc-line":"title-box_desc-line__WYlmq","desc2":"title-box_desc2__yGcCt"};